/*
 * @Author: chenguanghua
 * @Date: 2022-07-025 16:58:32
 * @LastEditors: cgh
 * @LastEditTime: 2022-09-07 18:55:11
 * @Description: 维保报告信息
 */

import axios from 'axios';
import config from '@/config';

const { iffApi } = config.ctx;

export const xccsdjManageService = {
  // 查询
  query: (params) => { return axios.get(`${iffApi}/xfwb/xccs`, { params: params }); },

  // 查看
  getDetail: (id) => { return axios.get(`${iffApi}/xfwb/xccs/${id}`); },

  // 删除
  delete: (id) => { return axios.delete(`${iffApi}/xfwb/xccs/${id}`); },

  // 导出
  export: (params) => { return axios.get(`${iffApi}/xfwb/xccs/export`, { responseType: 'blob', params }); }
};
